import { maLogger } from '@/base/logger'
import { RouteName } from '@/base/constants/route'
import { PRODUCTS } from '@/base/constants/authorization'

export const REDIRECT_MAP = Object.freeze({
  [PRODUCTS.COMPASS]: RouteName.APP_INTELLIGENCE_COMPASS_EXPLORE,
  [PRODUCTS.ASO_BUSINESS]: RouteName.APP_INTELLIGENCE_COMPASS_EXPLORE,
  [PRODUCTS.ASO_PRO]: RouteName.ASO_INTELLIGENCE_METADATA_ASO_OVERVIEW,
  [PRODUCTS.ASO_BASIC_V2]: RouteName.ASO_INTELLIGENCE_METADATA_ASO_OVERVIEW,
  [PRODUCTS.ASO_LITE]: RouteName.ASO_INTELLIGENCE_METADATA_ASO_OVERVIEW,
  [PRODUCTS.MARKET_ENTERPRISE]: RouteName.MARKET_INTELLIGENCE_ANALYSIS_APP_ANALYSIS,
  [PRODUCTS.MARKET_PRO]: RouteName.MARKET_INTELLIGENCE_ANALYSIS_APP_ANALYSIS,
  [PRODUCTS.AD_INTEL_ENTERPRISE]: RouteName.AD_INTELLIGENCE_ANALYSIS_CREATIVE_ANALYSIS,
  [PRODUCTS.SA_INTEL_ENTERPRISE]: RouteName.SEARCH_ADS_INTELLIGENCE_AD_PLACEMENT_SEARCH_RESULT_APP,
})

/**
 * The products that should not be considered for the default route.
 */
const EXCLUDED_PRODUCTS = [
  PRODUCTS.ADMIN_PRODUCT,
  PRODUCTS.MA_FREEMIUM,
  PRODUCTS.SA_FREEMIUM,
  PRODUCTS.ASA_FREEMIUM,
  PRODUCTS.SEARCH_ADS,
]

/**
 * Get the default route based on the products.
 * @param {object} options
 * @param {object} options.to - The route object.
 * @param {Array} options.products - The products array.
 * @returns {string} The default route name.
 */
export function getDefaultRoute({ to, products }) {
  try {
    let redirectRoute

    if (!Array.isArray(products) || !products.length) {
      throw new Error('Products are required to determine the default route.')
    }

    const { requiredProducts } = to.matched.find(m => !!m.meta?.requiredProducts).meta

    if (!Array.isArray(requiredProducts) || !requiredProducts.length) {
      throw new Error('"requiredProducts" are not defined.')
    }

    // The requiredProducts array is reversed to prioritize.
    const orderedProducts = requiredProducts.slice().reverse()

    for (const productName in orderedProducts) {
      const isExists = products.some(p => p.name == productName)
      if (isExists) {
        redirectRoute = REDIRECT_MAP[productName]
        break
      }
    }

    if (!redirectRoute) {
      const availableProducts = products.filter(({ name }) => !EXCLUDED_PRODUCTS.includes(name))
      redirectRoute = REDIRECT_MAP[availableProducts[0].name] || RouteName.ACCOUNT_SETTINGS_PLANS
    }

    return redirectRoute
  }
  catch (e) {
    maLogger.warn('[defaultRouteRedirects] Failed to module redirect:', e)
    return RouteName.ACCOUNT_SETTINGS_PLANS
  }
}
